import { type QueryFunctionContext, useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';

import type { IAIReport } from '@model/aiReport';

import { apiClient } from '@services/apiClient';

export const actionItemActiveReportKey = (actionItemId: string | number) => [
  'actionItemActiveReport',
  +actionItemId,
];

export const actionItemActiveReportFn = (
  queryKey: ReturnType<typeof actionItemActiveReportKey>,
  signal: AbortSignal | undefined,
) =>
  apiClient.get(`${APP_API_URL_V2}fsd/action-item/${queryKey[1]}/report`, {
    signal,
  });

const actionItemActiveReportSelect = ({
  data,
}: AxiosResponse<{ data: { report: IAIReport; type: string } }>) => {
  const report = data?.data?.report;
  if (report?.id) {
    return { ...report, is_no_actions: data?.data?.type === 'noActionReport' ? 1 : 0 };
  }

  return report;
};

export const useActionItemActiveReportQuery = ({ actionItemId }: { actionItemId: string | number }) => {
  return useQuery({
    // @ts-ignore TODO: update react-query to v5
    queryKey: actionItemActiveReportKey(actionItemId),
    queryFn: ({ queryKey, signal }: QueryFunctionContext<ReturnType<typeof actionItemActiveReportKey>>) =>
      actionItemActiveReportFn(queryKey, signal),
    enabled: !!actionItemId && actionItemId !== 'onboarding',
    useErrorBoundary: true,
    cacheTime: 1000,
    select: actionItemActiveReportSelect,
    placeholderData: {
      data: {
        data: {
          report: {},
        },
      },
    },
  });
};
